import { render, staticRenderFns } from "./MaterialExamSubject.vue?vue&type=template&id=3e4853a7&scoped=true"
import script from "./MaterialExamSubject.vue?vue&type=script&lang=js"
export * from "./MaterialExamSubject.vue?vue&type=script&lang=js"
import style0 from "./MaterialExamSubject.vue?vue&type=style&index=0&id=3e4853a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4853a7",
  null
  
)

export default component.exports